<!-- 时刻表 -->
<template>
  <div class="skb">
    <div v-if="syx" class="sub_title">每日8:00-18:30，每30分钟一班，双休日正常运行。</div>
    <img v-else class="my_img"  src="../../assets/image/skb2.jpg" alt="">
  </div>
</template>

<script>
export default {
  name: 'TimeTable',
  data() {
    return {
      syx: false,
    }
  },
  mounted(){
    if(this.$route.query.type == 'L821'){
      this.syx = false
    } else if(this.$route.query.type == 'L823'){
      this.syx = true
    } else{
      this.syx = false
    }
  }
}
</script>

<style lang="scss" scoped>
.skb {
  height: 100%;
  .sub_title {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    font-weight: 550;
    font-size: 14px;
  }
  .my_img {
    width: 100%;
    display: block;
  }
}
</style>
